import { gql } from '@grandvisionhq/graphql';

const CHECK_CUSTOMER_CONSENTS = gql`
  query CheckCustomerConsents($customerId: ID!, $consentName: String!) {
    checkCustomerConsents(customerId: $customerId, consentName: $consentName)
  }
`;

export { CHECK_CUSTOMER_CONSENTS };
//# sourceMappingURL=check-customer-consents.js.map
